import React, { useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import Particle from "../Particle";
import ProjectCard from "./ProjectCards";
import projectData from "./ProjectData";

function Projects() {
  const [activeCategory, setActiveCategory] = useState("website");

  const filteredProjects = projectData.filter(
    (project) => project.category === activeCategory,
  );

  return (
    <Container fluid className="project-section">
      <Particle />

      <Container>
        <h1 className="project-heading">
          My <strong className="purple">Projects</strong>
        </h1>

        <p style={{ color: "white" }}>
          Explore my projects across different technologies and domains.
        </p>

        {/* BUTTON FILTER */}

        <div className="project-filter">
          <Button
            className={`filter-btn ${
              activeCategory === "website" ? "active-filter" : ""
            }`}
            onClick={() => setActiveCategory("website")}
          >
            Website
          </Button>

          <Button
            className={`filter-btn ${
              activeCategory === "mobile" ? "active-filter" : ""
            }`}
            onClick={() => setActiveCategory("mobile")}
          >
            Mobile App
          </Button>

          <Button
            className={`filter-btn ${
              activeCategory === "uiux" ? "active-filter" : ""
            }`}
            onClick={() => setActiveCategory("uiux")}
          >
            UI / UX
          </Button>

          <Button
            className={`filter-btn ${
              activeCategory === "ml" ? "active-filter" : ""
            }`}
            onClick={() => setActiveCategory("ml")}
          >
            Machine Learning
          </Button>

          <Button
            className={`filter-btn ${
              activeCategory === "nlp" ? "active-filter" : ""
            }`}
            onClick={() => setActiveCategory("nlp")}
          >
            NLP
          </Button>

          <Button
            className={`filter-btn ${
              activeCategory === "gis" ? "active-filter" : ""
            }`}
            onClick={() => setActiveCategory("gis")}
          >
            GIS
          </Button>

          <Button
            className={`filter-btn ${
              activeCategory === "iot" ? "active-filter" : ""
            }`}
            onClick={() => setActiveCategory("iot")}
          >
            IoT
          </Button>
        </div>

        {/* PROJECT */}

        <Row style={{ justifyContent: "center", paddingBottom: "20px" }}>
          {filteredProjects.map((project) => (
            <Col md={4} className="project-card" key={project.id}>
              <ProjectCard project={project} />
            </Col>
          ))}
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
